import * as React from 'react';
import { __ } from 'react-i18n';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

import { AlertType } from 'eshop-defaults';
import { Loader } from 'eshop-defaults';

import AuthComponent from '../../components/Auth/AuthComponent';
import { UrlHashService } from '../../services/UrlHashService';

import {
  getLoginRoute,
  getLogoutRoute,
  getRegistrationRoute,
  getSuccesfullLoginMsg,
  loginTitle,
  registartionTitle,
} from 'eshop-defaults/lib/defaults';

import { loginUser, logoutUser } from './actions';

export enum AuthTab {
  Login,
  Register,
  Loading,
}

interface State {
  registerData: {
    email: string;
    pass: string;
    passAgain: string;
  };
  loading: boolean;
  tab: AuthTab;
  alert:
    | {
        msg: string;
        type: AlertType;
      }
    | undefined;
}

interface Props {
  metaTitle: string;
  isError: boolean;
  lang: string;
  defaultTitle: string;
  cartId: string;
  dispatch: (args: any) => void;
  API: any;
}

const LoaderWrapper = styled.div`
  height: 250px;
  padding-top: 130px;
`;

class Auth extends React.Component<Props, State> {
  static getDerivedStateFromProps(props, state) {
    const path = props.location.pathname;
    let tab = AuthTab.Login;
    if (path === getLoginRoute()) {
      tab = AuthTab.Login;
    } else if (path === getRegistrationRoute()) {
      tab = AuthTab.Register;
    } else if (path === getLogoutRoute()) {
      tab = AuthTab.Loading;
      props.dispatch(logoutUser());
    }

    const hashService = new UrlHashService();
    if (hashService.get('access_token')) {
      tab = AuthTab.Loading;
      props.dispatch(loginUser(hashService.get('access_token')));
      props.dispatch(push(__('routes:moj-ucet')));
    }

    if (state.tab !== tab) {
      return { ...state, tab };
    }

    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      alert: undefined,
      tab: AuthTab.Login,
      registerData: {
        email: '',
        pass: '',
        passAgain: '',
      },
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps || this.state !== nextState;
  }

  getLoginUrl = () => {
    return `${
      process.env.REACT_APP_API_BASE_URL
    }/oauth/authorize?redirect_uri=${process.env.REACT_APP_URL}${__(
      'routes:prihlasenie',
    )}&client_id=eshop&scope=all&cart_id=${this.props.cartId}`;
  };

  handleRegistration = async e => {
    e.preventDefault();

    this.setState({
      ...this.state,
      loading: true,
      alert: undefined,
    });

    const { email, pass, passAgain } = this.state.registerData;

    try {
      await this.props.API.registerUser(undefined, {
        email,
        password: pass,
        password_again: passAgain,
        lang: this.props.lang,
      });

      this.setState({
        ...this.state,
        loading: false,
        alert: {
          type: AlertType.Success,
          msg: getSuccesfullLoginMsg(),
        },
      });
    } catch (exp) {
      const errCode = exp.code;
      const msg = exp.details.description;
      let type = AlertType.Error;

      if (errCode === 404) {
        type = AlertType.Warning;
      }

      if (errCode === 400) {
        // Error
        type = AlertType.Warning;
      }

      if (errCode === 409) {
        // Error
      }

      this.setState({
        ...this.state,
        loading: false,
        alert: {
          type,
          msg,
        },
      });
    }
  };

  handleFacebook = () => {
    window.location.href = `${
      process.env.REACT_APP_API_BASE_URL
    }/oauth/facebook?state=${this.props.cartId}`;
  };

  handleGoogle = () => {
    window.location.href = `${
      process.env.REACT_APP_API_BASE_URL
    }/oauth/google?state=${this.props.cartId}`;
  };

  render() {
    const { tab, loading, registerData, alert } = this.state;
    const { defaultTitle } = this.props;

    if (tab !== AuthTab.Loading) {
      const title =
        tab === 0 ? loginTitle(defaultTitle) : registartionTitle(defaultTitle);
      return (
        <React.Fragment>
          {title && (
            <Helmet>
              <title>{title}</title>
            </Helmet>
          )}

          <AuthComponent
            alert={alert}
            tab={tab}
            closeAlert={this.closeAlert}
            loading={loading}
            registerData={registerData}
            updateRegisterData={this.updateRegData}
            getLoginUrl={this.getLoginUrl}
            handleRegistration={this.handleRegistration}
            handleGoogle={this.handleGoogle}
            handleFacebook={this.handleFacebook}
          />
        </React.Fragment>
      );
    }

    return (
      <LoaderWrapper>
        <Loader loading={true} />
      </LoaderWrapper>
    );
  }

  private closeAlert = () => {
    this.setState({
      ...this.state,
      alert: undefined,
    });
  };

  private updateRegData = (data: object): void => {
    this.setState({
      ...this.state,
      registerData: {
        ...this.state.registerData,
        ...data,
      },
    });
  };
}

const mapStateToProps = state => ({
  lang: state.general.lang,
  defaultTitle: state.general.title,
  cartId: state.cart.cartId,
});

export default connect(mapStateToProps)(Auth);
